import React from 'react';
import Badge from '../UI/Badge';
import Spacing from '../Spacing';
import { CircleAlert, CircleCheck, Info, QrCode, User } from 'lucide-react';
import Button from '../UI/Button';
import SearchForm from '../UI/SearchForm';
import DataTablePagination from '../DataTablePagination';
import DropdownWithSearch from '../DropdownWithSearch';
import Alert from '../UI/Alert';

export default function UIComponent() {
  return (
    <div className="docpro_grid docpro_grid_gap_20 docpro_grid_col_2">
      <div className="docpro_card docpro_card_2">
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
          <Badge color="green">Green</Badge>
          <Badge color="red">Red</Badge>
          <Badge color="orange">Orange</Badge>
          <Badge color="blue">Blue</Badge>
          <Badge color="purple">Purple</Badge>
          <Badge color="cyan">Cyan</Badge>
          <Badge color="indigo">Indigo</Badge>
          <Badge color="olive">Olive</Badge>
        </div>
        <Spacing lg="10" sm="10" />
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
          <Badge color="green" square>
            Green
          </Badge>
          <Badge color="red" square>
            Red
          </Badge>
          <Badge color="orange" square>
            Orange
          </Badge>
          <Badge color="blue" square>
            Blue
          </Badge>
          <Badge color="purple" square>
            Purple
          </Badge>
          <Badge color="cyan" square>
            Cyan
          </Badge>
          <Badge color="indigo" square>
            Indigo
          </Badge>
          <Badge color="olive" square>
            Olive
          </Badge>
        </div>
        <Spacing lg="10" sm="10" />
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
          <Badge color="green" square variant="size_lg">
            <Info height={16} width={16} /> Green
          </Badge>
          <Badge color="red" square variant="size_lg">
            <Info height={16} width={16} /> Red
          </Badge>
          <Badge color="orange" square variant="size_lg">
            <Info height={16} width={16} /> Orange
          </Badge>
          <Badge color="blue" square variant="size_lg">
            <Info height={16} width={16} /> Blue
          </Badge>
          <Badge color="purple" square variant="size_lg">
            <Info height={16} width={16} /> Purple
          </Badge>
          <Badge color="cyan" square variant="size_lg">
            <Info height={16} width={16} /> Cyan
          </Badge>
          <Badge color="indigo" square variant="size_lg">
            <Info height={16} width={16} /> Indigo
          </Badge>
          <Badge color="olive" square variant="size_lg">
            <Info height={16} width={16} /> Olive
          </Badge>
        </div>
      </div>
      <div className="docpro_card docpro_card_2">
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
          <Button filled>Add Patient</Button>
          <Button filled>
            <User width={20} height={20} />
            Add Patient
          </Button>
          <Button filled disabled>
            <User width={20} height={20} />
            Disabled
          </Button>
        </div>
        <Spacing lg="10" sm="10" />
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
          <Button filled lg>
            Add Patient
          </Button>
          <Button filled lg>
            <User width={20} height={20} />
            Add Patient
          </Button>
          <Button filled lg disabled>
            <User width={20} height={20} />
            Disabled
          </Button>
        </div>
        <Spacing lg="10" sm="10" />
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
          <Button>
            <QrCode width={20} height={20} /> Add Patient
          </Button>
          <Button disabled>
            <QrCode width={20} height={20} /> Add Patient
          </Button>
        </div>
        <Spacing lg="10" sm="10" />
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
          <Button lg>
            <QrCode width={20} height={20} /> Add Patient
          </Button>
          <Button lg disabled>
            <QrCode width={20} height={20} /> Add Patient
          </Button>
        </div>
      </div>
      <div className="docpro_card docpro_card_2">
        <SearchForm />
        <Spacing lg="10" sm="10" />
        <SearchForm variant="size_lg" />
      </div>
      <div className="docpro_card docpro_card_2">
        <DataTablePagination />
      </div>
      <div className="docpro_card docpro_card_2">
        <DropdownWithSearch placeholder="Select Status">
          <ul className="docpro_checkmark_list">
            <li>
              <div className="docpro_checkbox" style={{ top: '3px' }}>
                <input type="checkbox" />
                <label>
                  <span style={{ marginLeft: '8px' }}>
                    Breast cancer screening
                  </span>
                </label>
              </div>
            </li>
            <li>
              <div className="docpro_checkbox" style={{ top: '3px' }}>
                <input type="checkbox" />
                <label>
                  <span style={{ marginLeft: '8px' }}>Blue</span>
                </label>
              </div>
            </li>
            <li>
              <div className="docpro_checkbox" style={{ top: '3px' }}>
                <input type="checkbox" />
                <label>
                  <span style={{ marginLeft: '8px' }}>Peach</span>
                </label>
              </div>
            </li>
            <li>
              <div className="docpro_checkbox" style={{ top: '3px' }}>
                <input type="checkbox" />
                <label>
                  <span style={{ marginLeft: '8px' }}>Peach</span>
                </label>
              </div>
            </li>
            <li>
              <div className="docpro_checkbox" style={{ top: '3px' }}>
                <input type="checkbox" />
                <label>
                  <span style={{ marginLeft: '8px' }}>Peach</span>
                </label>
              </div>
            </li>
            <li>
              <div className="docpro_checkbox" style={{ top: '3px' }}>
                <input type="checkbox" />
                <label>
                  <span style={{ marginLeft: '8px' }}>Peach</span>
                </label>
              </div>
            </li>
          </ul>
        </DropdownWithSearch>
        <Spacing lg="10" sm="10" />
        <label className="docpro_fw_500 docpro_primary_color">Label</label>
        <input type="text" className="docpro_form_field" />
        <Spacing lg="10" sm="10" />
        <label className="docpro_fw_500 docpro_primary_color">
          Large Input
        </label>
        <input type="text" className="docpro_form_field size_lg" />
        <Spacing lg="10" sm="10" />
        <label className="docpro_fw_500 docpro_primary_color">
          Invalid Input
        </label>
        <input type="text" className="docpro_form_field size_lg danger_alert" />
      </div>
      <div className="docpro_card docpro_card_2">
        <h2 className="docpro_fs_24">Alert</h2>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
          <Alert
            color="green"
            btnText="Green Aleft"
            icon={<CircleCheck />}
            title="Title"
            subTitle="This is a description"
          />
          <Alert
            color="red"
            btnText="Green Aleft"
            icon={<CircleAlert />}
            title="Title"
            subTitle="This is a description"
          />
          <Alert
            color="orange"
            btnText="Green Aleft"
            icon={<CircleAlert />}
            title="Title"
            subTitle="This is a description"
          />
          <Alert
            color="blue"
            btnText="Green Aleft"
            icon={<CircleAlert />}
            title="Title"
            subTitle="This is a description"
          />
        </div>
      </div>
    </div>
  );
}
